<template>
  <modal-template class="modal-height"
                  size="intermedium-large"
                  close-position="left"
                  @close="$root.$emit('closeSignupPurchaseNoCreate')">
    <div class="posR">
      <div id="containerSignupPurchase"
           class="container-onboarding container-signup-purchase">
        <h3>{{ $t('signupPurchase.iniciaSesionEnWegowParaContinuarLaCompra') }}</h3>
        <b-row class="tAc mB20">
          <b-col cols="6">
            <button id="btnSignup"
                    :class="{'topaz': view === 'signup'}"
                    type="button"
                    class="btn transparent"
                    @click="view = 'signup'">{{ $t('signupPurchase.nuevoUsuario') }}</button>
          </b-col>
          <b-col cols="6">
            <button id="btnSignin"
                    :class="{'topaz': view === 'signin'}"
                    type="button"
                    class="btn transparent"
                    @click="view = 'signin'">{{ $t('signupPurchase.yaTengoCuenta') }}</button>
          </b-col>
        </b-row>
        <b-row v-if="view === 'signup'">
          <b-col cols="12">
            <validation-observer v-slot="{ invalid }">
              <b-form class="sign-up-form"
                      @submit.prevent="signupEmail">
                <validation-provider v-slot="{ errors }"
                                     rules="required|email">
                  <b-form-group>
                    <b-form-input id="emailSignup"
                                  v-model="model.email"
                                  type="email"
                                  required
                                  :placeholder="$t('signup.email')"
                                  name="email"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required|min:8">
                  <b-form-group>
                    <b-form-input id="passwordSignup"
                                  v-model="model.password"
                                  type="password"
                                  min-length="8"
                                  required
                                  :placeholder="$t('signup.contraseña')"
                                  name="password"
                                  :class="{'error': errors[0]}" />
                    <span class="help-text">{{ $t('signup.minimo8caracteres') }}</span>
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input id="firstName"
                                  v-model="model.first_name"
                                  type="text"
                                  required
                                  :placeholder="$t('basicInfoPurchase.nombre')"
                                  name="first_name"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input id="lastName"
                                  v-model="model.last_name"
                                  type="text"
                                  required
                                  :placeholder="$t('basicInfoPurchase.apellido')"
                                  name="last_name"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <b-form-row class="mB1rem">
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:2|max:2">
                      <b-form-input v-model="day"
                                    placeholder="DD"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="day"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:2|max:2">
                      <b-form-input v-model="month"
                                    placeholder="MM"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="month"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:4|max:4">
                      <b-form-input v-model="year"
                                    placeholder="YYYY"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="year"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                </b-form-row>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <input id="location"
                           ref="autocomplete"
                           :placeholder="$t('userProfileOnboarding.localizacion')"
                           :class="{'error': errors[0]}"
                           class="search-location form-control"
                           name="location"
                           type="text">
                  </b-form-group>
                </validation-provider>
                <b-form-group>
                  <w-switch id="gender"
                            v-model="model.gender"
                            :value-left="$t('genre.hombre')"
                            :value-right="$t('genre.mujer')" />
                </b-form-group>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group id="termsAcceptedCheckboxGroup">
                    <b-form-checkbox id="termsAcceptedCheckbox"
                                     v-model="model.terms_accepted"
                                     :class="{'error': errors[0]}"
                                     required>
                      <span v-html="$t('signup.aceptoLosTerminosYCondicionesYLaPoliticaDePrivacidad', {terms_and_conditions: 'https://www.wegow.com/es-es/terminos-y-condiciones/', privacy: 'https://www.wegow.com/es-es/aviso-legal/'})" />
                    </b-form-checkbox>
                  </b-form-group>
                </validation-provider>
                <b-form-group id="newsletterCheckboxGroup">
                  <b-form-checkbox id="newsletterCheckbox"
                                   v-model="model.newsletter">{{ $t('signupPurchase.meGustariaRecibirInformacionDeLasNovedadesDeConciertosYFestivalesDeWegow') }}</b-form-checkbox>
                </b-form-group>
                <div class="tAc">
                  <button :disabled="invalid || isDisabled"
                          :class="{'topaz': !invalid && !isDisabled, 'transparent': invalid || isDisabled}"
                          type="submit"
                          class="btn topaz">{{ $t('signupPurchase.continua') }}</button>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col cols="12">
            <span class="or-line">{{ $t('signupPurchase.o') }}</span>
          </b-col>
          <b-col cols="12"
                 class="tAc">
            <fb-signin-button v-if="model.terms_accepted"
                              :params="fbSignParams"
                              class="facebook-btn sign"
                              @success="onSignUpSuccess">
              <i class="facebook-icon" />
              {{ $t('signup.registrateConFacebook') }}
            </fb-signin-button>
            <div v-else
                 class="facebook-btn sign"
                 @click="modalTerms($t('signup.debesAceptarLosTerminosYCondiciones'))">
              <i class="facebook-icon" />
              {{ $t('signup.registrateConFacebook') }}
            </div>
          </b-col>
        </b-row>
        <b-row v-if="view === 'signin'">
          <b-col cols="12">
            <validation-observer v-slot="{ invalid }">
              <b-form @submit.prevent="signinEmail">
                <validation-provider v-slot="{ errors }"
                                     rules="required|email|confirmed:emailConfirmation">
                  <fieldset class="form-group">
                    <input id="emailSignup"
                           v-model="model.email"
                           name="email"
                           :placeholder="$t('signup.email')"
                           :class="{'error': errors[0]}"
                           type="email" />
                  </fieldset>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     vid="emailConfirmation"
                                     rules="required|email">
                  <fieldset class="form-group">
                    <input id="emailConfirmationSignup"
                           v-model="model.emailConfirmation"
                           name="email-confirmation"
                           :placeholder="$t('signup.emailConfirmation')"
                           :class="{'error': errors[0]}"
                           autocomplete="off"
                           onpaste="return false"
                           onCopy="return false"
                           onCut="return false"
                    />
                  </fieldset>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required|min:8">
                  <b-form-group>
                    <b-form-input id="passwordSignin"
                                  v-model="model.password"
                                  type="password"
                                  required
                                  :placeholder="$t('signup.contraseña')"
                                  name="password"
                                  :class="{'error': errors[0]}" />
                    <div class="tAr">
                      <a href="https://www.wegow.com/es-es/contrasena-olvidada/"
                         class="tUnder">{{ $t('signup.olvidasteLaContraseña') }}</a>
                    </div>
                  </b-form-group>
                </validation-provider>
                <div class="tAc">
                  <button :disabled="invalid || isDisabled"
                          :class="{'topaz': !invalid && !isDisabled, 'transparent': invalid || isDisabled}"
                          type="submit"
                          class="btn topaz">{{ $t('signupPurchase.entra') }}</button>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col cols="12">
            <span class="or-line">{{ $t('signupPurchase.o') }}</span>
          </b-col>
          <b-col cols="12"
                 class="tAc">
            <fb-signin-button :params="fbSignParams"
                              class="facebook-btn sign"
                              @success="onSignInSuccess">
              <i class="facebook-icon" />
              {{ $t('signupPurchase.continuaConFacebook') }}
            </fb-signin-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </modal-template>
</template>

<script>
import { userStatus } from '@/plugins/mixins/userStatus.js'
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'
import WSwitch from '@/components/wswitch/WSwitch.vue'
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    ModalTemplate,
    Loader,
    WSwitch
  },
  mixins: [userStatus],
  props: {
    eventToEmit: {
      type: String,
      default: 'closeSignupPurchase'
    }
  },
  data: () => ({
    model: {
      first_name: '',
      last_name: '',
      email: '',
      emailConfirmation: '',
      password: '',
      birthday: '',
      location: {},
      gender: undefined,
      newsletter: false,
      terms_accepted: false,
      signPurchaseEnv: process.env.NUXT_ENV
    },
    day: '',
    month: '',
    year: '',
    fbSignParams: {
      scope:
        'user_friends, email, public_profile, user_birthday, user_location, user_likes'
    },
    view: 'signup',
    loading: false,
    birthdayError: false
  }),
  computed: {
    isDisabled() {
      if (this.view === 'signup') {
        return (
          this.model.first_name === '' ||
          this.model.last_name === '' ||
          this.model.email === '' ||
          this.model.password.length < 8 ||
          this.birthdayError ||
          this.$moment().diff(
            this.$moment(
              this.day + '/' + this.month + '/' + this.year,
              'DD/MM/YYYY'
            ),
            'years'
          ) < 16 ||
          this.model.location.place_id === 'undefined' ||
          this.model.gender === undefined ||
          !this.model.terms_accepted
        )
      }
      return !this.model.email || !this.model.password
    }
  },
  mounted() {
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ['(cities)'] }
    )
    this.autocomplete.addListener('place_changed', () => {
      let place = this.autocomplete.getPlace()
      if (place && place.geometry && place.geometry.location) {
        this.model.location = {
          place_id: place.id,
          longitude: place.geometry.location.lng(),
          latitude: place.geometry.location.lat(),
          name: place.name
        }
      }
    })
  },
  methods: {
    fillBirthday() {
      if (this.day && this.month && this.year.length === 4) {
        if (
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'DD/MM/YYYY'
          ).isValid()
        ) {
          if (
            this.$moment().diff(
              this.$moment(
                this.day + '/' + this.month + '/' + this.year,
                'DD/MM/YYYY'
              ),
              'years'
            ) < 16
          ) {
            this.birthdayError = true
          } else {
            this.model.birthday = this.$moment(
              this.day + '/' + this.month + '/' + this.year,
              'DD/MM/YYYY'
            ).toDate()
            this.birthdayError = false
          }
        } else {
          this.birthdayError = true
        }
      }
    },
    modalTerms(text) {
      if (typeof CustomEvent === 'function') {
        var event = new CustomEvent('showError', {
          detail: {
            text: text
          }
        })
        window.dispatchEvent(event)
      }
    },
    signinEmail() {
      var data = {
        email: this.model.email,
        password: this.model.password,
        type: 'email',
        sign_up: false,
        first_name: '',
        last_name: ''
      }
      this._signin(data)
    },
    onSignInSuccess(response) {
      var data = {
        fb_token: response.authResponse.accessToken,
        type: 'facebook',
        first_name: '',
        last_name: ''
      }
      this._signin(data)
    },
    async _signin(data) {
      try {
        this.loading = true
        await this.$store.dispatch('auth/sign', { data: data, purchase: true })
        if (this.$store.state.auth.userIsAuthenticated) {
          await this.$store.dispatch('user/detail')
          await this.checkUserStatus().then(res => {
            this.$ga.set('userId', this.$store.state.user.detail.id)
            if (res === 'name' || res === 'profile') {
              this.$root.$emit('closeSignupPurchaseNoCreate')
              this.$root.$emit('openBasicInfoPurchase')
            } else {
              this.$root.$emit(this.eventToEmit)
              this.loading = false
            }
          })
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    signupEmail() {
      let data = {
        email: this.model.email,
        password: this.model.password,
        newsletter: this.model.newsletter,
        terms_accepted: this.model.terms_accepted,
        sign_up: true,
        first_name: this.model.first_name,
        last_name: this.model.last_name,
        gender: this.model.gender ? 'm' : 'f',
        birthday: this.$moment(this.model.birthday).format('YYYY-MM-DD'),
        location: this.model.location,
        type: 'email'
      }
      this._signup(data)
    },
    onSignUpSuccess(response) {
      var data = {
        fb_token: response.authResponse.accessToken,
        type: 'facebook',
        first_name: '',
        last_name: '',
        newsletter: this.model.newsletter,
        terms_accepted: this.model.terms_accepted,
        sign_up: true
      }
      if (this.model.terms_accepted) this._signup(data)
    },
    async _signup(data) {
      try {
        this.loading = true
        await this.$store.dispatch('auth/sign', { data: data, purchase: true })
        if (this.$store.state.auth.userIsAuthenticated) {
          await this.$store.dispatch('user/detail')
          await this.$store.dispatch('user/status')
          if (typeof window.fbq !== 'undefined') {
            window.fbq('track', 'Lead', {
              content_name: this.$store.state.event.detail.title
            })
          }
          if (data.type === 'facebook') {
            this.$root.$emit('closeSignupPurchaseNoCreate')
            this.$root.$emit('openBasicInfoPurchase')
          } else {
            this.$root.$emit(this.eventToEmit)
          }
          if (
            this.signPurchaseEnv === 'production' &&
            typeof window.google_trackConversion === 'function'
          ) {
            window.google_trackConversion({
              google_conversion_id: 966208932,
              google_conversion_language: 'en',
              google_conversion_format: '3',
              google_conversion_color: 'ffffff',
              google_conversion_label: 'N2nbCKys5XAQpNvczAM',
              google_remarketing_only: false
            })
          }
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import './signup-purchase.sass';
</style>
